import { Pt, pt } from "./pt";

class Bounds {
  lowX: number;
  lowY: number;
  highX: number;
  highY: number;

  constructor(lowX: number, lowY: number, highX: number, highY: number) {
    this.lowX = lowX;
    this.lowY = lowY;
    this.highX = highX;
    this.highY = highY;
  }

  expand(x: number, y: number): Bounds {
    return new Bounds(
      this.lowX - x,
      this.lowY - y,
      this.highX + x,
      this.highY + y
    );
  }

  get center(): Pt {
    return pt(this.centerX, this.centerY);
  }

  get centerX(): number {
    return this.lowX + this.width / 2;
  }

  get centerY(): number {
    return this.lowY + this.height / 2;
  }

  get width(): number {
    return this.highX - this.lowX;
  }

  get height(): number {
    return this.highY - this.lowY;
  }

  get topLeft(): Pt {
    return pt(this.lowX, this.lowY);
  }

  get topRight(): Pt {
    return pt(this.highX, this.lowY);
  }

  get bottomLeft(): Pt {
    return pt(this.lowX, this.highY);
  }

  get bottomRight(): Pt {
    return pt(this.highX, this.highY);
  }

  get top(): Pt {
    return pt(this.centerX, this.lowY);
  }

  get bottom(): Pt {
    return pt(this.centerX, this.highY);
  }

  get left(): Pt {
    return pt(this.lowX, this.centerY);
  }

  get right(): Pt {
    return pt(this.highX, this.centerY);
  }
}

function mergeBounds(ary: Bounds[]) {
  return new Bounds(
    Math.min(...ary.map((b) => b.lowX)),
    Math.min(...ary.map((b) => b.lowY)),
    Math.max(...ary.map((b) => b.highX)),
    Math.max(...ary.map((b) => b.highY))
  );
}

export { Bounds, mergeBounds };
